import {
    ChangeDetectorRef,
    Component,
    inject,
    OnDestroy,
    OnInit,
} from "@angular/core";
import { Subscription } from "rxjs";

import { Context, WINDOW } from "@hermes/core-app-core";
import { UrlUtils } from "@hermes/utils-generic-services-user-interface";

import { LayoutFacade } from "../../facades/layout.facade";
import { Message, MessageOption } from "../../model/notification.model";

const CHECKOUT_PAGE = "checkout";

/**
 * Notifications an loader handler
 */
@Component({
    selector: "h-overlay-error-message",
    templateUrl: "./overlay-error-message.component.html",
    styleUrls: ["./overlay-error-message.component.scss"],
})
export class OverlayErrorMessageComponent implements OnInit, OnDestroy {
    private layoutFacade = inject(LayoutFacade);
    private cd = inject(ChangeDetectorRef);
    private context = inject(Context);
    private urlUtils = inject(UrlUtils);
    private windowRefrence = inject<Window>(WINDOW);

    /** Message to display in the DOM */
    public message?: Message;

    private subscription: Subscription = new Subscription();

    public ngOnInit(): void {
        this.subscription.add(
            this.layoutFacade.notificationMessage$.subscribe(
                (messageOption: MessageOption) => {
                    if (messageOption) {
                        this.showNotification(messageOption);
                    } else {
                        this.clear();
                    }
                },
            ),
        );
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    /**
     * Public function to display the notification.
     * If it's a loader type, we display a Loader, else we deliver the message
     *
     * @param hermesEvent throw by the notificationsService
     */
    public showNotification(messageOption: MessageOption): void {
        this.clear();
        this.message = messageOption.message;
        this.cd.detectChanges();
    }

    /**
     * Allow to reload current path
     */
    public reloadCurrentPath(): void {
        if (this.context.isInBrowserMode()) {
            this.windowRefrence.location.reload();
        }
    }

    /**
     * Sends the user back to the homePage
     */
    public backToHome(): void {
        this.urlUtils.redirectToRootPath();
    }

    /**
     * Sends the user back to the checkout page
     */
    public backToCheckout(): void {
        this.urlUtils.redirectToPage(CHECKOUT_PAGE);
    }

    /**
     * Private Function to clear all messages when we close the Overlay
     */
    private clear(): void {
        this.message = undefined;
    }
}
